// extracted by mini-css-extract-plugin
export var colorSquare = "_tr-0";
export var danger = "_tr-5";
export var lightPink = "_tr-8";
export var neutralBlue = "_tr-7";
export var neutralYellow = "_tr-6";
export var normal = "_tr-1";
export var primary = "_tr-2";
export var primaryLight = "_tr-3";
export var solidBlack = "_tr-g";
export var solidGreen = "_tr-b";
export var solidLightBlue = "_tr-d";
export var solidNavy = "_tr-c";
export var solidOrange = "_tr-f";
export var solidPink = "_tr-e";
export var solidRed = "_tr-9";
export var solidYellow = "_tr-a";
export var success = "_tr-4";